// extracted by mini-css-extract-plugin
export default {"overlayLoaderWrapper":"OverlayLoader_overlayLoaderWrapper__jO8Z3"};